import { render } from "./InputPlusField.vue?vue&type=template&id=20489ffa"
import script from "./InputPlusField.vue?vue&type=script&lang=js"
export * from "./InputPlusField.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/MT/2025/jebsen/files/components/com_cruise/assets/js/booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__